import { createSlice } from "@reduxjs/toolkit";
import changeReviewStudyStatus from "@custom/rtk-apis/teleradiologist/changeReviewStudyStatus";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const changeReviewStudyStatusSlice = createSlice({
  name: "changeReviewStudyStatusSlice",
  initialState,
  reducers: {
    closeModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(changeReviewStudyStatus.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(changeReviewStudyStatus.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(changeReviewStudyStatus.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default changeReviewStudyStatusSlice.reducer;
export const { closeModal } = changeReviewStudyStatusSlice.actions;
